import { useImageBox, ImageBox } from '@/components';
import { DownOutlined } from '@ant-design/icons';
import { Space, Dropdown, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { BaselineImageDropdownMenu } from './BaselineImageDropdownMenu';

interface BaselineImageSelectControlProps {
  homeId: string;
  floorplanId: string;
  className?: string;
  setImageUrl: (imageUrl: string) => void;
}

export function BaselineImageSelectControl(
  props: BaselineImageSelectControlProps,
) {
  const { homeId, floorplanId, className, setImageUrl } = props;
  const { t } = useTranslation();

  const imageBox = useImageBox({
    defer: false,
    ownerId: homeId,
    ownerType: 'ProjectHomeFloorplanImage',
  });

  return (
    <>
      <Space direction="horizontal">
        <Dropdown
          className={className}
          overlay={
            <BaselineImageDropdownMenu
              floorplanId={floorplanId}
              homeId={homeId}
              onSave={setImageUrl}
              imageBox={imageBox}
            />
          }
          trigger={['click']}
        >
          <Typography.Link>
            <Space>
              <Space>
                {t('personalization.floorplan.selectImage')}
                <DownOutlined />
              </Space>
            </Space>
          </Typography.Link>
        </Dropdown>
      </Space>
      <ImageBox {...imageBox} galleryOnly></ImageBox>
    </>
  );
}
